import React from "react";
import { useTable } from "react-table";
import { useTranslation } from "react-i18next";
import "./InnerTable.scss";

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  // Render the UI for your table
  return (
    <table {...getTableProps()} role className="table-ex">

      {headerGroups.map(() => (
        <colgroup span={headerGroups.length}></colgroup>
      ))}
      {/* <div className="thead"> */}
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()} colspan={headerGroups.length} role>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()} role>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      {/* </div> */}

      {/* <div class="tbody"> */}
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} role>
              {row.cells.map((cell) => {
                return !cell.value ? (
                  <td {...cell.getCellProps()} role>{"0.00"}</td>
                ) : (
                  <td {...cell.getCellProps()} role>{cell.render("Cell")}</td>
                );
              })}
            </tr>
          );
        })}
      {/* </div> */}

    </table>
  );
}

function InnerTable({ data }) {
  const { t } = useTranslation("common");
  const columns = React.useMemo(
    () => [
      {
        Header: t("depositsInnerTable.employersReportInNIS"),
        columns: [
          {
            Header: t("depositsInnerTable.employeeBenefits"),
            accessor: "depEmployeeSum",
          },
          {
            Header: t("depositsInnerTable.employerBenefits"),
            accessor: "depEmployerSum",
          },
          {
            Header: t("depositsInnerTable.compensation"),
            accessor: "depCompensationSum",
          },
          {
            Header: t("depositsInnerTable.difference"),
            accessor: "depDifferentSum",
          },
        ],
      },
      {
        Header: t("depositsInnerTable.componentsAbsorptionInNIS"),
        columns: [
          {
            Header: t("depositsInnerTable.employeeBenefits"),
            accessor: "tranEmployeeSum",
          },
          {
            Header: t("depositsInnerTable.employerBenefits"),
            accessor: "tranEmployerSum",
          },
          {
            Header: t("depositsInnerTable.compensation"),
            accessor: "tranCompensationSum",
          },
          {
            Header: t("depositsInnerTable.difference"),
            accessor: "tranDifferentSum",
          },
        ],
      },
    ],
    []
  );

  return <Table columns={columns} data={data} />;
}

export default InnerTable;
